export const LOAD_LIST_JOB = 'LOAD_LIST_JOB';
export const LOAD_SERVICES = 'LOAD_SERVICES';
export const LOAD_JD = 'LOAD_JD';